import { render, staticRenderFns } from "./TargetPrizeImage.vue?vue&type=template&id=295efa31&scoped=true&"
import script from "./TargetPrizeImage.vue?vue&type=script&lang=js&"
export * from "./TargetPrizeImage.vue?vue&type=script&lang=js&"
import style0 from "./TargetPrizeImage.vue?vue&type=style&index=0&id=295efa31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295efa31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295efa31')) {
      api.createRecord('295efa31', component.options)
    } else {
      api.reload('295efa31', component.options)
    }
    module.hot.accept("./TargetPrizeImage.vue?vue&type=template&id=295efa31&scoped=true&", function () {
      api.rerender('295efa31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Barcode/components/TargetPrizeImage.vue"
export default component.exports